import {
  ChartRow,
  ChartRowElement,
  ChartRowGroup,
  ChartSubsection,
  ChartSubsectionContent,
  ChartSubsectionHeader,
} from "modules/charts-shared";
import { RADIOLOGY_GRID_COLUMNS } from "../radiology-chart/constants";
import { RadiologyInterpretationProps } from "../radiology-chart/types";
import { useFormContext } from "react-hook-form";

function F022Interpretation(props: RadiologyInterpretationProps) {
  const {
    index,
    chartCode,
    encounterId,
    sectionId,
    sectionCode,
    sectionSubCode,
    onRemoveElement,
  } = props;

  const { watch } = useFormContext();
  const sectionDelimiter = `rad.${index}.${chartCode}${sectionId}${sectionCode}${sectionSubCode}`;

  const isQ001A027Checked = Boolean(watch(`${sectionDelimiter}Q001A027`));
  const isQ001A028Checked = Boolean(watch(`${sectionDelimiter}Q001A028`));
  const isQ001A029Checked = Boolean(watch(`${sectionDelimiter}Q001A029`));
  const isQ001A030Checked = Boolean(watch(`${sectionDelimiter}Q001A030`));
  const isQ001A031Checked = Boolean(watch(`${sectionDelimiter}Q001A031`));

  return (
    <ChartSubsection
      header={
        <ChartSubsectionHeader
          showNotesBtn
          showDeleteBtn
          chartId={chartCode}
          encounterId={encounterId}
          sectionId={sectionCode}
          showInteractions={false}
          subsectionId={`${sectionSubCode}_Q001`}
          subsectionLabel="Ulna"
          showAuditsBtn={false}
          onDeleteSubSection={() => onRemoveElement(sectionId)}
        />
      }
      content={
        <ChartSubsectionContent>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement
                label="Ulna:"
                name={`${sectionDelimiter}Q001A001`}
                type="cross-option"
              />
              <ChartRowElement
                label="L"
                name={`${sectionDelimiter}Q001A002`}
                type="cross-option"
              />
              <ChartRowElement
                label="R"
                name={`${sectionDelimiter}Q001A003`}
                type="cross-option"
              />
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                label="proximal:"
                name={`${sectionDelimiter}Q001A004`}
                type="cross-option"
              />
              <ChartRowElement
                label="olecranon"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A005`}
                type="cross-option"
              />
              <ChartRowElement
                label="coronoid process:"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A006`}
                type="cross-option"
              />
              <ChartRowElement
                label="intra-articular"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A007`}
                type="cross-option"
              />
              <ChartRowElement
                label="torus"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A008`}
                type="cross-option"
              />
              <ChartRowElement
                name={`${sectionDelimiter}Q001A009`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                label="shaft:"
                name={`${sectionDelimiter}Q001A010`}
                type="cross-option"
              />
              <ChartRowElement
                label="transverse"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A011`}
                type="cross-option"
              />
              <ChartRowElement
                label="oblique"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A012`}
                type="cross-option"
              />
              <ChartRowElement
                label="spiral"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A013`}
                type="cross-option"
              />
              <ChartRowElement
                label="segmental"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A014`}
                type="cross-option"
              />
              <ChartRowElement
                label="comminuted"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A015`}
                type="cross-option"
              />
              <ChartRowElement
                label="Monteggia’s"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A016`}
                type="cross-option"
              />
              <ChartRowElement
                label="greenstick"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A017`}
                type="cross-option"
              />
              <ChartRowElement
                label="‘bent bone’"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A018`}
                type="cross-option"
              />
              <ChartRowElement
                name={`${sectionDelimiter}Q001A019`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
          <ChartRow gridTemplateColumns={RADIOLOGY_GRID_COLUMNS}>
            <ChartRowGroup>
              <ChartRowElement type="empty" />
            </ChartRowGroup>
            <ChartRowGroup>
              <ChartRowElement
                label="distal:"
                name={`${sectionDelimiter}Q001A020`}
                type="cross-option"
              />
              <ChartRowElement
                label="styloid"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A021`}
                type="cross-option"
              />
              <ChartRowElement
                label="transverse"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A022`}
                type="cross-option"
              />
              <ChartRowElement
                label="oblique"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A023`}
                type="cross-option"
              />
              <ChartRowElement
                label="comminuted"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A024`}
                type="cross-option"
              />
              <ChartRowElement
                label="torus"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A025`}
                type="cross-option"
              />
              <ChartRowElement
                label="SH:"
                name={`${sectionDelimiter}Q001A026`}
                type="cross-option"
              />
              <ChartRowElement
                label="1"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A027`}
                type="cross-option"
                isDisabled={
                  isQ001A028Checked ||
                  isQ001A029Checked ||
                  isQ001A030Checked ||
                  isQ001A031Checked
                }
              />
              <ChartRowElement
                label="2"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A028`}
                type="cross-option"
                isDisabled={
                  isQ001A027Checked ||
                  isQ001A029Checked ||
                  isQ001A030Checked ||
                  isQ001A031Checked
                }
              />
              <ChartRowElement
                label="3"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A029`}
                type="cross-option"
                isDisabled={
                  isQ001A027Checked ||
                  isQ001A028Checked ||
                  isQ001A030Checked ||
                  isQ001A031Checked
                }
              />
              <ChartRowElement
                label="4"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A030`}
                type="cross-option"
                isDisabled={
                  isQ001A027Checked ||
                  isQ001A028Checked ||
                  isQ001A029Checked ||
                  isQ001A031Checked
                }
              />
              <ChartRowElement
                label="5"
                fontStyle="italic"
                name={`${sectionDelimiter}Q001A031`}
                type="cross-option"
                isDisabled={
                  isQ001A027Checked ||
                  isQ001A028Checked ||
                  isQ001A029Checked ||
                  isQ001A030Checked
                }
              />
              <ChartRowElement
                name={`${sectionDelimiter}Q001A032`}
                type="input"
              />
            </ChartRowGroup>
          </ChartRow>
        </ChartSubsectionContent>
      }
    />
  );
}

export { F022Interpretation };
